var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row legenda text-right" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("strong", { staticClass: "text-primary" }, [_vm._v(" Ítens: ")]),
        _vm._v(_vm._s(_vm.qtdItens) + "\n      "),
        _c("strong", { staticClass: "text-primary" }, [_vm._v("| Produtos: ")]),
        _vm._v(" " + _vm._s(_vm.qtdProdutos) + "\n      "),
        _c("strong", { staticClass: "text-primary" }, [_vm._v(" | Total: ")]),
        _vm._v(" R$ " + _vm._s(_vm.valorTotal) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-striped table-responsive ml-3" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.tableData, function(data, index) {
          return _c("tr", { key: index, staticClass: "text-center" }, [
            _c("td", [_vm._v(_vm._s(data.codigo))]),
            _vm._v(" "),
            _c("td", { staticClass: "text-left" }, [_vm._v(_vm._s(data.nome))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(data.preco))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(data.quantidade))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(data.total))])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mt-3" }, [
      _c(
        "a",
        { attrs: { href: "#", onclick: "window.print();return false;" } },
        [_c("i", { staticClass: "fa fa-3x fa-print" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", [_vm._v("Produto")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Valor")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Quantidade")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Total")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3119cb61", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3119cb61","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/estoque/Imprimir.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3119cb61","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/estoque/Imprimir.vue
// module chunks = 2